import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import { CommonService } from 'src/providers/common';
import { AlertController, LoadingController, ModalController, ToastController, Platform } from '@ionic/angular';
import { FileUploadService } from 'src/providers/upload';
import { DomSanitizer } from "@angular/platform-browser";
import { DatePipe } from '@angular/common';
import { DatePikerPage } from '../date-piker/date-piker.page';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { AddmemPage } from '../addmem/addmem.page';
import { AddCall } from 'src/providers/addvCall';
import { GalleryCameraPage } from './gallery-camera/gallery-camera.page';
import { VaccinepopupPage } from '../vaccination-schedule/vaccinepopup/vaccinepopup.page';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  rate: any; months: any;
  presentView: string;

  profilePage: boolean;
  memberPage: boolean;
  addPage: boolean;
  editMemberPage: boolean;
  editmode: boolean = true;

  //API..........
  PatientProfile: any; showVaccinateBtn: any;
  PatientProfile1 = [];
  particularPro: any;
  importName: any;
  importGender: any;
  importDOB: any;
  importHeight: any;
  importWeight: any;
  importPhNum: any;
  editLabelValue: string = "Edit";
  editName: any;
  editDob: any;
  editMblNo: any;
  editEmail: any;
  editAdds: any;
  editExceptDlDate: any;
  editHeight: any;
  editweight: any;
  selectedDate: any;
  getMemName: any;
  getMemGender: any;
  getMemDob: any;
  getMemReletion: any;
  getMemHeight: any;
  getMemWeight: any;
  getMemMobileNo: any;
  reletionList: any;
  importMemReletion: any;
  memberType: any;
  memImg: any;
  isEdit: boolean = false;
  PatientProfileImage: any;
  editGender: any;
  checkError: boolean = false;
  todayDate: any;
  checkErrorWeight: boolean = false;
  CameraFileUpload: any;
  vaccineCount: any;
  PatientProfiledatas: any;
  Profiledatas: any;
  MaleImage = 'assets/newIcons/MaleJpg.jpg';
  FemaleImage = 'assets/newIcons/FeMaleJpg.jpg';
  EditPatientProfileImage:any;
  editmemImg:any;

  constructor(
    public toastController: ToastController,
    public fileupload: FileUploadService,
    public router: Router,
    public activeRoute: ActivatedRoute,
    private services: ServicesProvider,
    public alertCtrl: AlertController,
    private sanitizer: DomSanitizer,
    private datePipe: DatePipe,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public addCall: AddCall,
    private common: CommonService,
    public platform: Platform,
  ) { }

  ngOnInit() {
    this.CameraFileUpload = false;
  }

  doRefresh(event) {
    console.log('Begin async operation');

    setTimeout(() => {
      console.log('Async operation has ended');
      event.target.complete();
    }, 2000);
  }

  onImageErrors(event: Event,value:any): void {
    if(value == 'Male'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.MaleImage;
    }else if(value == 'Female'){
      const imgElement = event.target as HTMLImageElement;
      imgElement.src = this.FemaleImage;
    }
  }

  getFormattedDateTime(dateTime, callFor) {
    if (!dateTime) {
      return "";
    }

    let Value;
    switch (callFor) {
      case "Time":
        if (dateTime.indexOf("T") > -1) {
          Value = dateTime.split("T")[1];
        } else if (dateTime.indexOf(" ") > -1) {
          Value = dateTime.split(" ")[1];
        } else {
          Value = dateTime;
        }
        let hourEnd = Value.indexOf(":");
        let H = +String(Value).substr(0, hourEnd);
        let h = H % 12 || 12;
        let ampm = (H < 12 || H === 24) ? "AM" : "PM";
        let timeString = h + String(Value).substr(hourEnd, 3) + " " + ampm;
        return timeString;
      case "Date":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy");
      case "DateTime":
        return this.datepipeTransform(new Date(dateTime), "dd MMM yyyy h:mm a");
      case "Date1":
        if (this.addCall.selectedLanguage == 'en') {
          return this.datepipeTransform(new Date(dateTime), "dd-MMM-yy");
        } else if (this.addCall.selectedLanguage == 'ea') {
          let dateCall = new Date(dateTime);
          let months = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو",
            "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"
          ];
          const arDate = dateCall.getDate() + '-' + months[dateCall.getMonth()] + '-' + dateCall.getFullYear().toString().substr(-2);
          return arDate;
        }
    }
  }

  datepipeTransform(date: any, format: string): any {
    return this.datePipe.transform(date, format);
  }

  async openDatePickerPatientDOB() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        selectedDate: this.selectedDate,
        calenderType: "dob"    //normal/dob
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        console.log(data);
        if (data.data) {
          const DateValue = data.data
          this.editDob = this.getFormattedDateTime(DateValue, "Date1")
        }
      });
  }
  async openAddMemDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',
      componentProps: {
        selectedDate: this.selectedDate,
        calenderType: "dob"  
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        console.log(data);
        if (data.data) {
          let DateValue = data.data
          this.getMemDob = this.getFormattedDateTime(DateValue, "Date1");
        }
        console.log("selectedDate=>", this.getMemDob);
      });
  }
  arabDOB: any;

  validateDate(event: any) {
    debugger
    const selectedDate = event.target.value;
    console.log('Selected Date:', selectedDate);
    console.log('Today Date:', this.todayDate);

    if (selectedDate > this.todayDate) {
      this.presentToast("Future date is not acceptable");
      event.target.value = this.todayDate; 
    }
  }

  async openDatePicker3(event) {
    debugger
    if (this.addCall.selectedLanguage == 'ea') {
      let inputDateString = event.target.value;
      let date = new Date(inputDateString);
      this.arabDOB = { month: 'long' };
      let formattedMonth = new Intl.DateTimeFormat('ar-EG', this.arabDOB).format(date);
      let dayYearParts = inputDateString.split('-');
      let day = dayYearParts[2];
      let year = dayYearParts[0].toString().substr(-2);
      this.importDOB = `${day}-${formattedMonth}-${year}`;
      console.log("arab", this.importDOB);
    } else {
      this.importDOB = this.datepipeTransform(new Date(event.target.value), "dd MMM yy");
      this.getMemDob = event.target.value;
      console.log(this.importDOB, "this.importDOB");
    }
  }

  async openEditMemDatePicker() {
    const datePickerModal = await this.modalCtrl.create({
      component: DatePikerPage,
      cssClass: 'datePicker',

      componentProps: {
        selectedDate: this.selectedDate,
        calenderType: "dob",  
        curdate: new Date().toString().split(' ')[0] + ", " + new Date().toString().split(' ')[1] + " " + new Date().toString().split(' ')[2]
      }
    });
    await datePickerModal.present();

    datePickerModal.onDidDismiss()
      .then((data) => {
        console.log(data);
        if (data.data) {
          const DateValue = data.data
          this.importDOB = this.getFormattedDateTime(DateValue, "Date1");
        }
        console.log("selectedDate=>", this.getMemDob);
      });
  }

  async presentToast(tostMsg) {
    const toast = await this.toastController.create({
      message: tostMsg,
      duration: 2000,
      cssClass: 'toastStyle',
    });
    toast.present();
  }
  async AlertInfo(msg, status) {
    const alert = await this.modalCtrl.create({
      component: PopupalertPage,
      cssClass: 'class_alert',
      componentProps: {
        'msg': msg,
        'sts': status,
      }
    });
    await alert.present();
  }

  //------------Special Function's----------//

  ionViewWillEnter() {
    this.presentView = "profilePage";
    this.profilePage = true;
    this.CameraFileUpload = false;
    this.PatientProfile = null;
    this.memberPage = false;
    this.addPage = false;
    this.editMemberPage = false;
    this.editmode = true;
    this.editLabelValue = this.addCall.title253;
    this.getPatientProfile();
    this.getPatientReletion();

  }
  numberOnlyValidation(event: any) {
    const pattern = /[0-9.,]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  backToHome() {
    if (localStorage.getItem("profileFlow") == "pregnantFlow" || localStorage.getItem("profileFlow") == "motherFlow") {
      this.router.navigate(['/tabs/pregnant-mother']);
      console.log("back to Mother flow Pagr");
    } else if (this.editLabelValue == this.addCall.title259) {
      this.profilePage = true;
      this.presentView = "profilePage";
      this.editmode = true;
      this.editLabelValue = this.addCall.title253;
    }
    else if (localStorage.getItem("profileFlow") == 'MenWomen') {
      this.router.navigate(['/tabs/home']);
    }
  }

  openLina(index) {
    this.showVaccinateBtn = false;
    this.particularPro = this.PatientProfile1[index];
    const validRelationIds = [2, 44, 55, 60];
    const relation_id = this.PatientProfile.patientmemberDetails[index].relation_id
    console.log(this.particularPro);
    let ageValue = this.getAge(this.PatientProfile.patientmemberDetails[index].dob);
    if (ageValue < 18 && validRelationIds.includes(relation_id)) {
      this.showVaccinateBtn = true;
    }
    this.presentView = "memberPage";
    this.memberPage = true;

    this.profilePage = false;
    this.addPage = false;
    this.editMemberPage = false;
    for (let item of this.reletionList) {
      if (item.PatientrealationshipId == this.particularPro.relation_id) {
        this.memberType = item.realationship;
        break;
      }
    }
  }

  async addMember() {
    const modal = await this.modalCtrl.create({
      component: AddmemPage,
      cssClass: 'Add-Member-Page',
      componentProps: {
        getMemName: "",
        getMemGender: "",
        getMemReletion: "",
        getMemHeight: "",
        getMemWeight: "",
        getMemMobileNo: "",
        membDOB: "",
        getMemDob: "",
        memProImg: ""
      },
    });
    modal.onDidDismiss()
      .then((data) => {
        const res = data;
        console.log(res);
        if (res.data.from == 2) {
          this.getPatientProfile();
        }
      });
    return await modal.present();
  }

  getPatientReletion() {
    this.services.getRequest("getpatientrelation").subscribe(res => {
      console.log(res);
      this.reletionList = res.data;
      console.log("reletionList=>", this.reletionList);
    });
  }

  backToProfile() {
    this.profilePage = true;
    this.presentView = "profilePage";
    this.showVaccinateBtn = false;
    this.memberPage = false;
    this.addPage = false;
    this.editMemberPage = false;
  }

  editMember() {
    debugger;
    this.todayDate = new Date().toISOString().split('T')[0];
    this.memImg = this.particularPro.patientMemberImage;
    this.importName = this.particularPro.name;
    this.importGender = this.particularPro.gender;
    this.importDOB = this.getFormattedDateTime(this.particularPro.dob, "Date1");
    this.importMemReletion = String(this.particularPro.relation_id);
    this.importHeight = this.particularPro.height;
    this.importWeight = this.particularPro.weight;
    this.importPhNum = this.particularPro.phone_no;
    this.fileupload.setfilepath(this.particularPro.patientMemberImage);
    this.presentView = "editMemberPage";
    this.editMemberPage = true;
    this.profilePage = false;
    this.memberPage = false;
    this.addPage = false;
    this.checkError = false;
    this.checkErrorWeight = false;
  }

  async UpdateMemberDetails() {
    this.height_emptyError(this.importHeight);
    this.width_emptyError(this.importWeight)
    if (!this.checkError  && !this.checkErrorWeight) {
      const loading = await this.loadingController.create({
        message: this.addCall.title507,
      });
      let getDob;
      if (this.importDOB != null && this.addCall.selectedLanguage == 'en') {
        let d = new Date(this.importDOB);
        getDob = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
      } else if (this.addCall.selectedLanguage == 'ea' && this.importDOB != null) {
        getDob = this.convertDateFormat(this.importDOB);
      }
      else {
        getDob = null;
      }


      let apiData = JSON.stringify({
        "parentpatientId": localStorage.getItem("patient_id"),
        "patientId": this.particularPro.PatientMemberId,
        "name": this.importName,
        "imagearray": this.editmemImg,
        "gender": this.importGender,
        "dob": getDob,         
        "relationId": this.importMemReletion,
        "heightcm": this.importHeight,
        "weightkg": this.importWeight,
        "phoneno": this.importPhNum,
        "modifiedby": localStorage.getItem("patient_id")
      });
      this.services.postRequest("addPatientmemberDetails", apiData).subscribe(async res => {
        console.log(res);
        setTimeout(async () => {
          await loading.dismiss();
        }, 500);
        if (res.status == 1) {        
          this.AlertInfo(this.addCall.title591, res.status);
          this.ionViewWillEnter();
        }
      });
    }
  }

  backToMember() {
    this.presentView = "memberPage";
    this.memberPage = true;
    this.fileupload.setfilepath(this.PatientProfile.profile_image);
    this.addPage = false;
    this.editMemberPage = false;
  }


  editProfile() {
    if (this.editLabelValue == this.addCall.title253) {
      this.editmode = false;
      this.editLabelValue = this.addCall.title259;
    }
    else if (this.editLabelValue == this.addCall.title259) {
      if (!this.CameraFileUpload) {
        this.editmode = true;
        this.editLabelValue = this.addCall.title253;
        console.log(this.editName, this.editDob, this.editMblNo, this.editGender, this.editEmail,
        this.editAdds, this.editHeight, this.editweight, this.editExceptDlDate, "edit-profile-details");
        this.editDetails();
      }
    }
  }

  editDetails() {
    let Dob;
    if (this.editDob != null && this.addCall.selectedLanguage != "ea") {
      let d = new Date(this.editDob);
      Dob = d.getFullYear() + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + ("0" + d.getDate()).slice(-2);
      console.log("EditDob=>", this.editDob);
      console.log("Dob=>", Dob);
    } else if (this.addCall.selectedLanguage == "ea" && this.editDob != null) {
      Dob = this.convertDateFormat(this.editDob)
      console.log("Dob=>", Dob);
    }
    else {
      Dob = null;
    }
    let requestdata = JSON.stringify({
      "name": this.editName,
      "dob": Dob,
      "email": this.editEmail,
      "phone_no": this.editMblNo,
      "gender": this.editGender,
      "address": this.editAdds,
      "expected_del_date": this.editExceptDlDate,
      "modifiedby": localStorage.getItem("patient_id"),
      "userType": null,
      "babyName": null,
      "id": localStorage.getItem('patient_id'),
      "image_path": this.EditPatientProfileImage,
      "Weight": this.editweight,
      "Height": this.editHeight
    });

    this.services.postRequest('editpatientdetails', requestdata).subscribe(res => {
      console.log('editMultiple=>', res);
      this.AlertInfo(this.addCall.title583, res.status);
      this.getPatientProfile();
    });

  }

  // Define months in Arabic and their corresponding numeric values
  convertDateFormat(inputDate) {
    const arabicMonths = {
      "يناير": "01",
      "فبراير": "02",
      "مارس": "03",
      "أبريل": "04",
      "مايو": "05",
      "يونيو": "06",
      "يوليو": "07",
      "أغسطس": "08",
      "سبتمبر": "09",
      "أكتوبر": "10",
      "نوفمبر": "11",
      "ديسمبر": "12"
    };

    const dateParts = inputDate.split("-");
    const day = dateParts[0];
    const month = arabicMonths[dateParts[1]];
    const year = dateParts[2];
    return `${year}-${month}-${day}`;
  }


  //API Integration...................

  getPatientProfile() {
    let currentDate = new Date(Date.now()).toISOString().split("T")[0];
    let currentTime = new Date(Date.now()).toLocaleTimeString().split(" ")[0];
    let requestdata = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": currentDate,
      "currentTime": currentTime
    });
    this.services.postRequest("getPatientProfile", requestdata).subscribe(response => {
      debugger;
      console.log("Patient Profile => ", response);
      this.PatientProfile = response.data[0];
      console.log(this.PatientProfile);
      this.PatientProfile1 = response.data[0].patientmemberDetails;
      this.PatientProfiledatas = response.data[0].patientmemberDetails;
      this.editName = this.PatientProfile.name;
      this.editGender = this.PatientProfile.gender;
      this.editDob = this.getFormattedDateTime(this.PatientProfile.dob, "Date1");
      this.editMblNo = this.PatientProfile.phone_no;
      this.editEmail = this.PatientProfile.email;
      this.editAdds = this.PatientProfile.address;
      this.editExceptDlDate = this.PatientProfile.expected_del_date;
      this.fileupload.setfilepath(this.PatientProfile.profile_image);
      this.common.profileImage = this.PatientProfile.profile_image;
      this.EditPatientProfileImage = this.PatientProfile.profile_image.split('?')[0];
      this.getMembervacinationNotificationsCount();

      this.editHeight = this.PatientProfile.height == null ? "-" : this.PatientProfile.height;

      this.editweight = this.PatientProfile.weight == null ? '-' : this.PatientProfile.weight;

      console.log("datas=>", this.editName,this.editDob,this.editMblNo,this.editGender,this.editEmail,
        this.editAdds,this.editExceptDlDate,this.fileupload)
    });
  }


  goToProfile() {
    this.isEdit = !this.isEdit
  }

  uploadPhoto(event: any) {
    this.CameraFileUpload = true;
    this.PatientProfileImage = "";
    this.EditPatientProfileImage = "";
    const formData = new FormData();
    formData.append('module_id', "66");
    formData.append('file', event.target.files[0]);
    formData.append('pathLocation', "PROFILE/");

    this.services.imageUploadS3Bucket("admin/awsS3FileUpload", formData).subscribe(response => {
      console.log("resposeeehhhhhuploadimageblobToBinary", response);
      this.PatientProfile.profile_image = response.filepath.Location;
      this.PatientProfileImage = response.filepath.privatePathUrl;
      this.EditPatientProfileImage = response.filepath.privatePathUrl;
      this.memImg = response.filepath.Location;
      this.editmemImg = response.filepath.Location;
      const interval = setInterval(() => {
        this.CameraFileUpload = false;
        clearInterval(interval);
      }, 1200);
      console.log("resposeeehhhhhuploadimagefilepath", this.PatientProfile.profile_image);
    });
  }

  uploadCamera(eve: any) {
    if (this.platform.is("ios")) {
      this.CameraFileUpload = true;
      this.PatientProfileImage = "";
      this.EditPatientProfileImage = "";
      const formData = new FormData();
      formData.append('module_id', "66");
      formData.append('file', eve.target.files[0]);
      formData.append('pathLocation', "PROFILE/");

      this.services.imageUploadS3Bucket("admin/awsS3FileUpload", formData).subscribe(response => {
        console.log("resposeeehhhhhuploadimageblobToBinary", response);
        if (response.filepath.Location != '') {
          this.PatientProfile.profile_image = response.filepath.Location;
          this.PatientProfileImage = response.filepath.privatePathUrl;
          this.EditPatientProfileImage = response.filepath.privatePathUrl;
          const interval = setInterval(() => {
            this.CameraFileUpload = false;
            clearInterval(interval);
          }, 1200);
          console.log("resposeeehhhhhuploadimagefilepath", this.PatientProfile.profile_image);
        } else {
          this.PatientProfile.profile_image = this.PatientProfile.profile_image;
          this.CameraFileUpload = false;
        }
      });
    } else if (this.platform.is("android")) {
      this.CameraFileUpload = true;
      this.PatientProfileImage = "";
      this.EditPatientProfileImage = "";
      this.fileupload.openCameras("1").then((res) => {
        console.log("check the response", res);
        if (res[0] != '0') {
          this.PatientProfile.profile_image = res[0];
          this.PatientProfileImage = res[2];
          this.EditPatientProfileImage = res[2];
          console.log('file name', this.PatientProfile.profile_image);
          console.log("filepath1res0", this.PatientProfileImage ,"EditPatientProfileImage",this.EditPatientProfileImage);
          const interval = setInterval(() => {
            this.CameraFileUpload = false;
            clearInterval(interval);
          }, 1200);
        } else {
          this.PatientProfile.profile_image = this.PatientProfile.profile_image;
          this.CameraFileUpload = false;
        }
      });
    }
  }

  async uploadCameraProfile() {
    if (!this.editmode) {
      const modal = await this.modalCtrl.create({
        component: GalleryCameraPage,
        backdropDismiss: false,
        cssClass: 'profileGallery',
      });

      modal.onDidDismiss().then((data) => {
        console.log("message==>", data);
        if (data.data.From == 1) {
          this.CameraFileUpload = true;
          this.uploadCamera(data.data.To);
        } else if (data.data.From == 2) {
          this.CameraFileUpload = true;
          this.uploadPhoto(data.data.To);
        } else {
          console.log("Form", data.data);
        }
      });
      return await modal.present();
    }
  }

  getProfilepath() {
    setTimeout(() => {
      console.log("filepath2", this.fileupload.getfilepath());
    }, 3000);
  }

  goToVaccination(PatientId) {
    console.log(PatientId,"details",this.PatientProfile.gender);
    this.router.navigate(['/tabs/vaccination-schedule', { patient_id: PatientId, gender: this.PatientProfile.gender}]);
    
  }

  getAge(dateString) {
    let today = new Date();
    let birthDate = new Date(dateString);
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }
  clearHeight() {
    this.editHeight = this.PatientProfile.height == null || this.PatientProfile.height == '-' ? '' : this.PatientProfile.height;
  }
  clearWeight() {
    this.editweight = this.PatientProfile.weight == null || this.PatientProfile.weight == '-' ? '' : this.PatientProfile.weight;
  }
  height_emptyError(height) {
    if (!height || height == '') {
      this.checkError = true;
    }
    else {
      this.checkError = false;
    }
  }
  width_emptyError(width) {
    if (!width || width == '') {
      this.checkErrorWeight = true;
    }
    else {
      this.checkErrorWeight = false;
    }
  }
  navigateToNotification(index){
    console.log(this.PatientProfile1[index]);
    this.router.navigate(['/tabs/commonNotification', { moduleid: 99, patient_id: this.PatientProfile1[index].PatientMemberId}])
  }
  getMembervacinationNotificationsCount(){
    let apiData = {
      "patientId": localStorage.getItem("patient_id"),
    }
    this.services.postRequest("getMembervacinationNotificationsCount", apiData).subscribe(response => {
      console.log("getMembervacinationNotificationsCount",response)
      this.vaccineCount = response.data
      this.profileDatas();
    });
  }

  profileDatas(){
    console.log(this.PatientProfiledatas);
    console.log(this.vaccineCount);
    this.PatientProfiledatas.forEach(profile => {
      // Find the corresponding vaccine count data based on patient_id
      const vaccineData = this.vaccineCount.find(vaccine => vaccine.patient_id === profile.PatientMemberId);
      
      // If vaccine data is found, assign notify_count to the profile
      if (vaccineData) {
          profile.notify_count = vaccineData.notify_count;
      } else {
          // If no vaccine data is found, assign notify_count as 0
          profile.notify_count = 0;
      }
      
  });
  this.Profiledatas = this.PatientProfiledatas;
  console.log(this.PatientProfiledatas);
  console.log(this.vaccineCount);
  }


  async deleteProfile(matchingPatient) {
    let popup = await this.modalCtrl.create({
      component: VaccinepopupPage,
      componentProps: {
        'data': matchingPatient,
        'ProfileDelete': 1,
      },
      cssClass: 'class_alert'
    })
    popup.onDidDismiss().then((data) => {
      try {
        console.log(data.data, 'datas',matchingPatient);
        if (data.data == 1) {
          console.log(data.data, 'datas',matchingPatient);
          let apiData = {
            "isActive": 0,
            "patientId": matchingPatient.PatientMemberId
          }
          this.services.postRequestGndrl("Patient/deletePatientDetails", apiData).subscribe(res => {
          console.log(res);
          this.ionViewWillEnter();
          })
        }
      } catch (error) {
        console.log("error", error);
      }

    });
    await popup.present();
  }
}
